import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With a background spanning defense, consultancy, and banking, how has your diverse
                experience shaped your approach to cybersecurity leadership in a complex environment
                like Mashreq?
              </strong>
            </h5>

            <h5 className="text-white">
              My journey—from defense and national security to consultancy and global banking—has
              instilled a pragmatic, mission-driven approach to cybersecurity.
              <br />
              <br />
              From my time in defense, I learned the importance of understanding threats and risks
              in depth, along with the value of discipline, resilience, and strategic foresight.
              Consultancy sharpened my ability to adapt across industries, regions and cultures,
              while banking taught me to position cybersecurity beyond traditional protection, as a
              business enabler that supports priorities and fosters trust across stakeholders and
              clients.
              <br />
              <br />
              At Mashreq, this translates into a leadership style that is structured yet agile, able
              to navigate regulatory complexity, enable strategic initiatives, and contribute to
              digital transformation while fostering a culture of trust across the organization.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve emphasized enabling the business to take calculated risks. How do you
                strike a balance between innovation and security, especially in a rapidly
                digitalizing banking ecosystem?
              </strong>
            </h5>
            <h5 className="text-white">
              Balancing innovation with security begins with understanding the organization’s
              strategy, its appetite for risk, and translating this into actionable security
              strategies founded on trust.
              <br />
              <br />
              In previous roles I led programs that safeguarded assets while enabling innovation and
              reinforcing stakeholder confidence. Whether securing cloud-native environments or
              enabling secure digital channels, we focus on embedding security into the development
              lifecycle and governance frameworks.
              <br />
              <br />
              At Mashreq, we advocate for security-by-design approach and apply risk-based
              decision-making, ensuring innovation advances responsibly and is built on a strong
              foundation of mutual trust.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Having led the first Red Team for the French National Information Security Agency,
                how do you see offensive security and threat simulation evolving within the
                financial sector?
              </strong>
            </h5>
            <h5 className="text-white">
              Offensive security has evolved from a niche capability to a strategic necessity. My
              experience building and leading the Red Team at ANSSI over two decades ago
              demonstrated the value of simulating real-world adversaries to uncover blind spots and
              reinforce trust in our defenses. In banking, threat simulations are now integral to
              resilience strategies—moving beyond compliance checkboxes to proactive defense. I see
              financial institutions investing more in adversary emulation, purple teaming, and
              continuous validation of controls. The goal is not just to test defenses, but to
              foster a culture of readiness, resilience, continuous improvement, and above all,
              trust—integrated into our business-as-usual activities.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-What are the biggest cyber and privacy risks you see emerging for banks in the
                MENA region over the next few years, and how is Mashreq preparing for them?
              </strong>
            </h5>
            <h5 className="text-white">
              The MENA region faces a unique convergence of risks: rapid digitalization,
              geopolitical tensions sometimes supported by and motivating cybersecurity activities,
              and evolving regulatory landscapes. Key threats include supply chain vulnerabilities,
              cloud misconfigurations, and data sovereignty challenges. Privacy risks are
              intensifying with stricter data protection laws and rising customer expectations
              around trust and security. Here is an opportunity for banks to lead in setting new
              benchmarks for protection and transparency.
              <br />
              <br />
              Mashreq is proactively advancing its cyber and privacy capabilities by strengthening
              the security of our digital products and services by default, enhancing our on-prem
              and cloud security posture, improving third-party risk management, and ensuring our
              privacy and data protection frameworks meet regional and global standards. Drawing on
              my experience in Swiss and European banking environments, our approach is
              forward-looking, compliance-aware lens, always prioritizing the trust our clients and
              partners place in us.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As cybersecurity increasingly becomes a board-level concern, how do you
                communicate cyber risk in business terms to executive leadership and stakeholders?
              </strong>
            </h5>
            <h5 className="text-white">
              Effective communication starts with translating technical risk into business impact.
              In previous roles, I reported regularly to executive committees and boards, framing
              cybersecurity in terms of business risk mitigation, operational resilience, maturity
              of the security posture and regulatory exposure. We use qualitative—and increasingly
              quantitative—risk models, scenario-based storytelling, and clear metrics to make cyber
              risk tangible and foster trust between technical and business stakeholders. <br />
              <br />
              At Mashreq, we continue to bridge the gap between Information Security, Business,
              Technology, and Digital teams, ensuring leadership sees cybersecurity as a strategic
              asset and enabler, and that trust remains at the heart of every decision we make.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
